import { INTERP } from './CommonConstants';
import variables from '../../styles/colors.module.scss';

const { RED, YELLOW, GREEN, GREEN_AT_ABOVE, BLUE, PASS, NO_PASS } = INTERP;
const {
    redinterp: redInterp,
    greeninterp: greenInterp,
    yellowinterp: yellowInterp,
    blueinterp: blueInterp,
} = variables;
export const BENCHMARK = {
    WELL_BELOW: 'Well Below Benchmark',
    BELOW: 'Below Benchmark',
    AT: 'At Benchmark',
    AT_OR_ABOVE: 'At or Above Benchmark',
    ABOVE: 'Above Benchmark',
    PASS: 'Pass',
    NO_PASS: 'No Pass',
};

export const COMMON_INTERP_MAPPER = {
    [BENCHMARK.WELL_BELOW]: RED,
    [BENCHMARK.BELOW]: YELLOW,
    [BENCHMARK.AT]: GREEN,
    [BENCHMARK.AT_OR_ABOVE]: GREEN_AT_ABOVE,
    [BENCHMARK.ABOVE]: BLUE,
    [BENCHMARK.PASS]: PASS,
    [BENCHMARK.NO_PASS]: NO_PASS,
};

export const INTERP_COLOR_MAPPER = {
    [RED]: redInterp,
    [YELLOW]: yellowInterp,
    [GREEN]: greenInterp,
    [GREEN_AT_ABOVE]: greenInterp,
    [BLUE]: blueInterp,
};

export const DEFAULT_INTERPS = [RED, YELLOW, GREEN, BLUE];

export const getCommonInterpretation = interp => COMMON_INTERP_MAPPER[interp];

export const getInterpretationNameByKey = key =>
    Object.keys(COMMON_INTERP_MAPPER).find(name => COMMON_INTERP_MAPPER[name] === key);
